import elPro from "../../assets/img/elpro.svg";
import React from "react";
import { CarouselInstrucciones } from "../CarouselInstruciones";

export const AsistenteSubirDocs = ({ instrucciones }) => {
    return (
        <div className="col-xl-3">
            <div className="card p-3 d-flex justify-content-center align-content-center card-asistente bg-white">
                <div className={"m-2 row"}>
                    <div className={"col-8 col-md-12"}>
                        <h4 className={"text-primary font-weight-bold"}>Reporta aquí tus siniestros</h4>
                        {!instrucciones ? (
                            <small>
                                <p className={"text_align-center "}>
                                    Haz clic en “subir documentos” para que puedas cargar los documentos relacionados a
                                    tu siniestro.
                                </p>
                            </small>
                        ) : (
                            <br />
                        )}
                    </div>
                    <div className={"col-4 col-md-12"}>
                        <img src={elPro} alt="..." className={"asistente-big m-3"} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export const AsistenteInstrucciones = () => {
    return (
        <div className="col-lg-3">
            <div className="card p-3 d-flex justify-content-center align-content-center h-100 siniestros-instrucciones">
                <div>
                    <h4 className={"text-primary"}>Instrucciones</h4>

                    <CarouselInstrucciones />
                </div>
            </div>
        </div>
    );
};
